'use client'

import React from 'react'

import { FunnelFrame } from '@/components/landing/papr-funnel/styles'
import { LiveRegister } from '@/components/landing/papr-funnel/auth-live'

export const dynamic = 'force-dynamic'

export default function RegisterPage() {
  return (
    <React.Suspense fallback={null}>
      <FunnelFrame>
        <LiveRegister />
      </FunnelFrame>
    </React.Suspense>
  )
}
